import { useTranslation } from 'react-i18next'
import { Button } from './Button'

interface FormNavigationProps {
  onBack?: () => void
  onNext?: () => void
  backLabel?: string
  nextLabel?: string
  nextDisabled?: boolean
  backDisabled?: boolean
  isSubmit?: boolean
}

export function FormNavigation({
  onBack,
  onNext,
  backLabel,
  nextLabel,
  nextDisabled = false,
  backDisabled = false,
  isSubmit = true,
}: FormNavigationProps) {
  const { t } = useTranslation()

  const resolvedBackLabel = backLabel || t('common.back')
  const resolvedNextLabel = nextLabel || t('common.next')

  return (
    <>
      {/* Spacer for fixed button area on mobile */}
      <div className="h-20 md:hidden" />

      {/* Fixed on mobile, normal flow on desktop */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-border p-4 pb-[max(1rem,env(safe-area-inset-bottom))] md:relative md:bg-transparent md:border-0 md:p-0 md:mt-10">
        <div className="flex justify-between max-w-md mx-auto md:max-w-none">
          {onBack ? (
            <Button type="button" variant="secondary" onClick={onBack} disabled={backDisabled}>
              {resolvedBackLabel}
            </Button>
          ) : (
            <div />
          )}
          <Button type={isSubmit ? 'submit' : 'button'} onClick={onNext} disabled={nextDisabled}>
            {resolvedNextLabel}
          </Button>
        </div>
      </div>
    </>
  )
}
